import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from './Icon';
export const IconIndicator = ({ ...props }) => {
    const id = useId();
    return (<IconWithGradient id={id} defaultGradientKey="darkPurple" {...props}>
      <Path d="M16 8.50023L18.3642 6.13609M5.63631 18.864L8.00026 16.5M17.6566 12.5H21M3 12.5H6.34315M12 6.84342L12 3.5M12 21.5L12 18.1569M8.00023 8.50023L5.63609 6.13609M18.364 18.864L16 16.5" stroke={`url(#gradient_${id})`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </IconWithGradient>);
};
